module.exports = __webpack_public_path__ + "static/media/bq.8c6f85c7.svg";